import styled, { css } from "styled-components";

export const desktopMixin = css`
  flex-direction: row;
  justify-content: flex-end;

  h1 {
    font-size: 3rem;
  }

  img {
    min-width: 300px;
    max-width: 567px;
    width: 100%;
    margin-bottom: 0;
    order: 0;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  ${(props) => (props.desktop ? desktopMixin : "")}
`;

export const bigMixin = css`
  margin-left: 8em;
  padding: 2em 93px 2em 2em;
`;

export const Content = styled.div`
  padding: 2em;

  ${(props) => (props.big ? bigMixin : "")}
`;

export const Photo = styled.img`
  user-select: none;
  width: 100%;
  max-width: 400px;
  align-self: flex-end;
  order: -1;
  margin-bottom: -5em;
`;
